import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { Select, MenuItem, FormControl } from '@mui/material';
import { v4 } from 'uuid';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import {
  clnGameSeason, useCalendarSplit,
} from '../../../../utils/exchange';
import { IAppState } from '../../../../state/reducers';
import { resetActiveAsset } from '../../../../state/exchange/activeAsset';
import {
  toggleFilterBySeason,
  fetchScheduleSeasons,
} from '../../../../state/exchange/searchParams';
import { ControlLabel } from '../styles';
import {
  SeasonSelectClass,
  SeasonSelectorContainer,
} from './styles';

class SeasonSelection extends PureComponent<IProps> {
  componentDidMount() {
    const { fetchSeasons } = this.props;
    fetchSeasons();
  }

  handleSeasonChange = (e: any) => {
    const {
      toggleSeason,
      clearActiveAsset,
    } = this.props;
    const seasonFilter = e.target.value;
    toggleSeason(seasonFilter);
    clearActiveAsset();
  };

  render() {
    const {
      seasons,
      seasonFilter,
      sport,
    } = this.props;

    return (
      <SeasonSelectorContainer>
        <ControlLabel>
          Season:
        </ControlLabel>
        <FormControl variant="standard">
          <Select
            className={SeasonSelectClass}
            onChange={(e) => this.handleSeasonChange(e)}
            value={seasonFilter ?? ''}
            disabled={!seasons.length}
            data-auto="SeasonSelect"
            data-loaded={seasons.length > 0}
          >
            <MenuItem value="" data-season="All" key={v4()}>All</MenuItem>
            {seasons.map((season) => (
              <MenuItem value={useCalendarSplit(sport) ? clnGameSeason(season) : season} data-season="Season" key={v4()}>{season}</MenuItem>
            ))}
          </Select>
        </FormControl>

      </SeasonSelectorContainer>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  seasons: state.exchange.searchParams.seasons,
  isFilterBySeason: state.exchange.searchParams.isFilterBySeason,
  seasonFilter: state.exchange.searchParams.seasonFilter,
  sport: state.exchange.initExchange.sport,
});

const mapDispatchToProps: IDispatchProps = {
  toggleSeason: toggleFilterBySeason,
  fetchSeasons: fetchScheduleSeasons,
  clearActiveAsset: resetActiveAsset,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SeasonSelection);
